const APPLE_JS_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
let appleScriptPromise = null;
function loadAppleIdScript() {
    if (window.AppleID != null) {
        return Promise.resolve();
    }
    if (appleScriptPromise == null) {
        appleScriptPromise = new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.src = APPLE_JS_SDK_URL;
            script.async = true;
            script.onload = ()=>resolve();
            script.onerror = ()=>reject(new Error('failed to load the Apple Sign-In JS SDK'));
            document.head.appendChild(script);
        });
    }
    return appleScriptPromise;
}
export function makeWebAppleAuth() {
    return {
        async signIn (param) {
            let { nonce, scopes } = param;
            var _ref, _ref1;
            var _response_user_name, _response_user, _response_user_name1, _response_user1;
            const clientId = window.appleAuthServicesId;
            if (clientId == null || clientId === '') {
                throw new Error('Apple Services ID not configured for web Sign in with Apple');
            }
            await loadAppleIdScript();
            if (window.AppleID == null) {
                throw new Error('Apple Sign-In JS SDK unavailable after load');
            }
            window.AppleID.auth.init({
                clientId,
                scope: scopes.join(' '),
                redirectURI: window.location.origin,
                nonce,
                usePopup: true
            });
            const response = await window.AppleID.auth.signIn();
            if (response.authorization.id_token == null || response.authorization.id_token === '') {
                throw new Error('empty idToken from web Apple Sign-In');
            }
            return {
                credential: response.authorization.id_token,
                firstName: (_ref = (_response_user = response.user) === null || _response_user === void 0 ? void 0 : (_response_user_name = _response_user.name) === null || _response_user_name === void 0 ? void 0 : _response_user_name.firstName) !== null && _ref !== void 0 ? _ref : undefined,
                lastName: (_ref1 = (_response_user1 = response.user) === null || _response_user1 === void 0 ? void 0 : (_response_user_name1 = _response_user1.name) === null || _response_user_name1 === void 0 ? void 0 : _response_user_name1.lastName) !== null && _ref1 !== void 0 ? _ref1 : undefined
            };
        }
    };
}
